import script from "./AppBlogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBlogs.vue?vue&type=script&setup=true&lang=ts"

import "./AppBlogs.vue?vue&type=style&index=0&id=843ddb3a&lang=css"

const __exports__ = script;

export default __exports__